module.exports = __webpack_public_path__ + "img/sdg13.130861c8.svg";